export default "__VITE_ASSET__CWe7hfCk__"